/*
 * @Descripttion: router
 * @version: 1
 * @Author: guantingting
 * @Date: 2019-07-24 14:13:42
 * @LastEditors  : guantingting
 */

// entering 会被重定向  不要定义entering路径
import Vue from 'vue'
import Router from 'vue-router'
import jsCookie from 'js-cookie'
import fetch from '@/plugins/fetch'
import tracker from '../plugins/tracker'
import utils from '../plugins/utils'
import { isHZWAPP } from '@/utils'
import selfPhoto from './selfPhoto/route'
Vue.use(Router)

const scrollBehavior = (to, from, savedPosition) => {
  if (savedPosition) {
    return savedPosition
  } else {
    const position = {}
    if (to.hash) {
      position.selector = to.hash
    }
    if (to.matched.some(m => m.meta.scrollToTop)) {
      position.x = 0
      position.y = 0
    }
    return position
  }
}
const router = new Router({
  mode: 'history',
  scrollBehavior,
  base: '/v/',
  routes: [
    {
      // 首页-内部现已自动跳转到/h5/home
      path: '/home',
      name: 'home',
      component: () => import('./index/index')
    },
    {
      // 同上
      path: '/indexPage',
      name: 'indexPage',
      component: () => import('./index/index')
    },
    {
      // 育儿顾问列表（育儿顾问在线咨询）
      path: '/consultantList',
      name: 'consultantList',
      component: () => import('./consultantList/index')
    },
    {
      // 每日秒杀（已停用？）
      path: '/secKill',
      name: 'secKill',
      component: () => import('./activity/secKill')
    },
    {
      // 服务商品列表
      path: '/product',
      name: 'products',
      component: () => import('./home/product')
    },
    {
      // 服务详情（服务类商品详情）
      path: '/product/:spuId',
      name: 'product-detail',
      component: () => import('./home/index'),
      /* eslint-disable*/
      meta: { scrollToTop: true }
    },
    {
      // 预确认下单
      path: '/product/:spuId/confirm',
      name: 'product-confirm',
      component: () => import('./home/confirm')
    },
    {
      // 支付成功
      path: '/order/pay-success',
      name: 'pay-success',
      component: () => import('./order/paySuccess'),
      meta: { scrollToTop: true }
    },
    {
      // 支付失败
      path: '/order/pay-fail',
      name: 'pay-fail',
      component: () => import('./order/payFail'),
      meta: { scrollToTop: true }
    },
    {
      // POS支付（投放不明）
      path: '/order/payment/:orderId',
      name: 'payment',
      component: () => import('./order/payment')
    },
    {
      // 订单列表
      path: '/user/order',
      name: 'order-list',
      component: () => import('./order/list')
    },
    {
      // 退款流程
      path: '/order/:orderId/refund',
      name: 'order-refund',
      component: () => import('./order/refund'),
      meta: { scrollToTop: true }
    },
    {
      // 订单详情
      path: '/order/:orderCode',
      name: 'order-detail',
      component: () => import('./order/detail'),
      meta: { scrollToTop: true }
    },
    {
      // 拼团详情
      path: '/order/group/:groupId',
      name: 'order-group',
      component: () => import('./groupBuy/groupDetail')
    },
    {
      // 评价成功
      path: '/order/:orderCode/comment/success',
      name: 'comment-success',
      component: () => import('./comment/success'),
      meta: { scrollToTop: true }
    },
    {
      // 评价分享？（投放不明）
      path: '/order/:orderCode/comment/share',
      name: 'comment-share',
      component: () => import('./comment/share'),
      meta: { scrollToTop: true }
    },
    {
      // 发表评价 对商品订单
      path: '/order/:orderCode/comment/add',
      name: 'comment-add',
      component: () => import('./comment/add'),
      meta: { scrollToTop: true }
    },
    {
      // 评价列表 对 订单商品
      path: '/product/:spuId/comments',
      name: 'comments',
      component: () => import('./comment'),
      meta: { scrollToTop: true }
    },
    {
      // 发表评价 对 服务人员？
      path: '/user/:uid/comment/add',
      name: 'comment-user-add',
      component: () => import('./comment/add'),
      meta: { scrollToTop: true }
    },
    {
      // 评价列表 对 育儿顾问 认证育儿师
      path: '/comments/:workerCode',
      name: 'comment-list',
      component: () => import('./comment/serviceCommentLists'),
      meta: { scrollToTop: true }
    },
    {
      // 无用评价？（objId评价对象下的无用评价）
      path: '/meaningLessComments/:id',
      name: 'meaningLessComments',
      component: () => import('./comment/meaningLessCommentList'),
      meta: { scrollToTop: true }
    },
    {
      // 新版发表评价
      path: '/evaluate',
      name: 'evaluate',
      component: () => import('./evaluate'),
      meta: { scrollToTop: true }
    },
    {
      // 服务人员列表（2列宫格）（投放不明）
      path: '/workers/:serviceType?',
      name: 'worker',
      component: () => import('./work/list')
    },
    {
      // 选择服务日期
      path: '/date',
      name: 'date',
      component: () => import('./date/index')
    },
    {
      // ？？？？
      path: '/user/:uid/work',
      name: 'worker-date',
      component: () => import('./date/personal_work'),
      meta: { scrollToTop: true }
    },
    {
      // 人格化主页
      path: '/user/:uid',
      name: 'user',
      component: () => import('./rear'),
      meta: { scrollToTop: true }
    },
    {
      // ？？？？
      path: '/user',
      name: 'user-no',
      component: () => import('./rear'),
      meta: { scrollToTop: true }
    },
    {
      // 服务人员对服务列表
      path: '/user/:uid/service',
      name: 'service',
      component: () => import('./rear/service')
    },
    {
      // 服务人员营业执照
      path: '/user/:uid/licence',
      name: 'service-licence',
      component: () => import('./rear/licence')
    },
    {
      // 服务人员对被评价列表
      path: '/user/:uid/evaluate',
      name: 'evaluate',
      component: () => import('./rear/evaluate'),
      meta: { scrollToTop: true }
    },
    {
      // 我的育儿经（服务人员的育儿经）
      path: '/user/:uid/experience',
      name: 'experience',
      component: () => import('./rear/experience'),
      meta: { scrollToTop: true }
    },
    {
      // 孩子王认证育儿师招募 入驻
      // 例如 /entering/step0
      path: '/entering/step:stepNo',
      name: 'entering',
      component: () => import('./preEntering')
    },
    {
      // 孩子王月嫂招募 入驻
      // 例如 /entering/step0
      path: '/yuesao/step:stepNo',
      name: 'entering-yuesao',
      component: () => import('./preEntering/yuesao')
    },
    {
      // 门店服务人员
      path: '/store/workers',
      name: 'store-worker-list',
      component: () => import('./work/list4Store')
    },
    {
      // 孩子王金牌月嫂-品宣页（旧）
      path: '/collect',
      name: 'collect',
      component: () => import('./collect')
    },
    {
      // 孩子王金牌月嫂-填写预约表单（旧）
      path: '/collect-fill',
      name: 'collect-fill',
      component: () => import('./collect/fill')
    },
    {
      // 所有品类列表（原育儿旧版）
      path: '/categorylist',
      name: 'categorylist',
      component: () => import('./category/categoryList')
    },
    {
      // 所有品类列表（原育儿更旧版）
      path: '/category',
      name: 'category',
      component: () => import('./category/index')
    },
    {
      // 对应tab下的商品列表
      path: '/category/t/:searchId',
      name: 'category-detail',
      component: () => import('./category/spuList')
    },
    {
      // 对应分类下商品列表
      path: '/category/p/:cateId',
      name: 'category-product',
      component: () => import('./category/spuList')
    },
    {
      // 分享赚页面
      path: '/activity/share',
      name: 'activity-share',
      component: () => import('./activity/share')
    },
    {
      // 新版分享赚页面
      path: '/activity/newShare',
      name: 'activity-newShare',
      component: () => import('./activity/newShare')
    },
    {
      // 分享赚 - 我的清单
      path: '/activity/mysharelist',
      name: 'activity-mysharelist',
      component: () => import('./activity/myShareList')
    },
    {
      // 育儿服务拼团列表
      path: '/groupBuy/groupList',
      name: 'group-buy',
      component: () => import('./groupBuy/index')
    },
    {
      // 拼团商详
      path: '/groupBuy/groupInfo/:spuId',
      name: 'group-info',
      component: () => import('./groupBuy/groupInfo')
    },
    {
      // 正在拼团中列表
      path: '/groupBuy/moreGroups',
      name: 'more-groups',
      component: () => import('./groupBuy/moreGroups')
    },
    {
      // 服务日志列表
      path: '/service-log/list/:origin/:type/:orderId',
      name: 'log-list',
      component: () => import('./serviceLog/serviceList')
    },
    {
      // 服务日志订单列表
      path: '/service-order/list',
      name: 'service-order',
      component: () => import('./serviceLog/orderList')
    },
    {
      // 日志编辑
      path: '/service-log/edit/:id',
      name: 'log-edit',
      component: () => import('./serviceLog/logEdit')
    },
    {
      // 日志查看
      path: '/service-log/view/:origin/:id',
      name: 'log-view',
      component: () => import('./serviceLog/logView')
    },
    {
      // 产后恢复？？
      path: '/recovery',
      name: 'recovery',
      component: () => import('./recovery')
    },
    {
      // 产后恢复？？
      path: '/recovery-detail',
      name: 'recovery-detail',
      component: () => import('./recovery/detail')
    },
    {
      // 产后恢复-营业执照
      path: '/recovery-licence',
      name: 'recovery-licence',
      component: () => import('./recovery/licence')
    },
    {
      // 产后恢复？？
      path: '/total-comment',
      name: 'total-comment',
      component: () => import('./recovery/total-comment')
    },
    {
      // 育儿大学（旧）
      path: '/articles',
      name: 'articles',
      component: () => import('./articles')
    },
    {
      // 服务优惠--拼团秒杀列表，带切换城市
      path: '/groupandseckill',
      name: 'groupandseckill',
      component: () => import('./groupAndSeckill')
    },
    {
      // 话题
      path: '/pregnancytopic',
      name: 'pregnancytopic',
      component: () => import('./pregnancyTopic')
    },
    {
      // 地图位置-高德
      path: '/map',
      name: 'map',
      component: () => import('./map')
    },
    {
      // 月嫂预下单（仅对 签约月嫂）
      path: '/confirmYuesao',
      name: 'confirmYuesao',
      component: () => import('./confirmYuesao/index')
    },
    {
      // 代客下单月嫂月嫂预下单 （仅对 签约月嫂）
      path: '/confirmYuesaoValetOrder',
      name: 'confirmYuesaoValetOrder',
      component: () => import('./confirmYuesaoValetOrder')
    },
    {
      // 添加/修改出行人
      path: '/addPerson',
      name: 'addPerson',
      component: () => import('./person-add')
    },
    {
      // 全屏查看图片
      path: '/viewImageFullScreen',
      name: 'viewImageFullScreen',
      component: () => import('./viewImageFullScreen/index.vue')
    },
    selfPhoto
  ]
})
// router.beforeEach((to, from, next) => {
//   const __Loading = window.__Loading
//   if (!__Loading.show) {
//     __Loading.show = true
//   }
//   next()
// })
/* prettier-ignore 暂存后续去掉*/
// router.beforeEach((to, from, next) => {
//   try {
//     if(to && to.name != 'consultantList') {
//       const { href } = router.resolve({name:'consultantList',query:{cmd:'share',sharetype:'0'}})
//       location.replace(href);
//     } else {
//       next()
//     }

//   } catch (e) {
//     next()
//   }
// })
/* prettier-ignore */
router.afterEach((route) => {
  //添加百度统计
  utils.setBaiduTrack()

    try {
        tracker(route)
        if (Object.keys(route.query).indexOf('_debug') > -1) {
              import('vconsole').then(vconsole => {
                  new vconsole.default()
              })
        }
        const hserecomkey = route.query.hserecomkey || ''
        let firstHserecomkey = ''
        // if (route.query.hserecomkey && route.query.hserecomkey !== '') {
        if (hserecomkey instanceof Array) { // 防止链接上有多个分享key
            jsCookie.set('hserecomkey', hserecomkey[0], {
                domain: '.cekid.com'
            })
            firstHserecomkey = hserecomkey[0]
        } else if (hserecomkey === 'undefined') {
            jsCookie.set('hserecomkey', '', {
                domain: '.cekid.com'
            })
        } else {
            jsCookie.set('hserecomkey', hserecomkey, {
                domain: '.cekid.com'
            })
        }
        //如果是数组时 删除多余的hserecomkey
        if(firstHserecomkey){
          const newQuery = { ...route.query };
          delete newQuery.hserecomkey; 
          newQuery.hserecomkey = firstHserecomkey; 
          router.replace({ query: newQuery });
        }
    } catch (e) {
        console.log(e);
    }
})
export default router
